














































































import { Component, Ref, Vue } from "vue-property-decorator";
import AttachmentsView from "@/components/AttachmentsView/index.vue";
import ExportWord from "@/components/DownloadWord/index.vue";
import AuditBlock, {AuditApi} from "@/components/Audit/AuditBlock.vue";

import {
  CapitalIncomeRecordFromDonationDetailDto,
  CapitalIncomeRecordFromDonationDto,
  AttachmentHostType,
  AuditFlowScope,
} from "@/api/appService";
import api from "@/api";
import moment from "moment";
@Component({
  name: "CapitalIncomeRecordFromDonationDetail",
  components: {
    AttachmentsView,
    ExportWord,
    AuditBlock,
  },
})
export default class CapitalIncomeRecordFromDonationDetail extends Vue {

  detailId?: number;
  detail: CapitalIncomeRecordFromDonationDto = {};
  selector = "table-detail";
  filename = "资金捐赠详情";
  styles = "";
  get hostTypeFile() {
    return AttachmentHostType.Internal_Project_Monthly_Summarize_Attachment;
  }

  created() {
    if (this.$route.params.id) {
      this.detailId = Number(this.$route.params.id);
      this.fetchDetail();
    }
  }
  // 获取详情
  async fetchDetail() {
    await api.capitalIncomeRecordFromDonation
      .get({ id: this.detailId })
      .then((res) => {
        this.detail = { ...res };
      });
  }


  get auditApi(){
    return {
      canAudit: api.capitalIncomeRecordFromDonation.canAudit,
      userAudit: api.capitalIncomeRecordFromDonation.audit
    } as AuditApi
  }

  // 返回
  private cancel() {
    this.$router.back();
  }
}
